import React, { useState, useRef, useEffect } from 'react';

interface PinCardProps {
  pinIndex: number;
  initialLabel?: string;
  required?: boolean;       // default true (preserves existing behavior)
  placeholder?: string;     // default "Label this point..."
  onSave: (label: string) => void;
  onDelete: () => void;
  onClose: () => void;
}

export const PinCard: React.FC<PinCardProps> = ({
  pinIndex,
  initialLabel = '',
  required,
  placeholder,
  onSave,
  onDelete,
  onClose,
}) => {
  const [label, setLabel] = useState(initialLabel);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSave = () => {
    const trimmed = label.trim();
    if (required !== false && !trimmed) return; // block empty submit for required mode
    onSave(trimmed);
    onClose();
  };

  return (
    <div className="pa-pin-card" onClick={e => e.stopPropagation()}>
      <div className="pa-pin-card-header">
        <span className="pa-pin-card-num">{pinIndex}</span>
        <span className="pa-pin-card-title">What is this?</span>
      </div>
      <input
        ref={inputRef}
        type="text"
        className="pa-pin-card-input"
        value={label}
        onChange={e => setLabel(e.target.value.slice(0, 80))}
        placeholder={placeholder ?? 'Label this point...'}
        maxLength={80}
        onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
      />
      <div className="pa-pin-card-actions">
        <button className="pa-pin-card-delete" onClick={onDelete}>Remove</button>
        <button className="pa-pin-card-save" onClick={handleSave}>Done</button>
      </div>
    </div>
  );
};
